import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=1e20b268"
import script from "./Services.vue?vue&type=script&scoped=true&lang=js"
export * from "./Services.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=1e20b268&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports